import {Component, OnInit, Input, SimpleChanges, SimpleChange, OnChanges} from '@angular/core';
import * as $ from 'jquery';
import {TranslateServiceService} from '../translate-service.service';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router, NavigationEnd} from '@angular/router';
import {Header} from './Header';
import {FormBuilder, FormGroup} from '@angular/forms';
import {HeaderBackgroundService} from '../header-background.service';
import {Location} from '@angular/common';
import {Globals} from '../globals';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

import {AdvancedSearchComponent} from './advanced-search/advanced-search.component';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  defaultImg;
  ZinuzhImg;
  HayzinvorImg;
  AsparImg;
  DzaynadaranImg;
  TesasrahImg;
  FotosrahImg;


  headerImage: any;
  dataTypes;
  dataLang = '../../assets/img/armenia-flag-icon-16.png';
  imageLang;

  header: Header;
  lang;
  langs = [];
  varSearch;
  langForm: FormGroup;
  langValue: string;
  test;

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    public globals: Globals,
    public headerBack: HeaderBackgroundService,
    public route: ActivatedRoute,
    public matDialog: MatDialog,
    private router: Router,
    public _location: Location,
    private translateService: TranslateServiceService) {


    this.lang = localStorage.getItem('lang') == undefined ? 'hy' : localStorage.getItem('lang');

    if (this.router.url.length <= 1) {
      this.translateService.langData(this.lang);
    }

    this.langs['hy'] = 'Հայ';
    this.langs['ru'] = 'Рус';
    this.langs['en'] = 'Eng';

  }

  // clearInputSearch() {
  //   $('#txtSearchProdAssign').val('');

  //    setTimeout(() => {
  //     location.reload()
  //   }, 300);
  // }

  // clearInputSearch1() {
  //   $('#txtSearchProdAssign1').val('');

  //    setTimeout(() => {
  //     location.reload()
  //   }, 300);
  // }


  headerSend;

  setHeaderLang(lang) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('localization', lang);
    this.headerSend = headers;
  }


  search() {
    $('#txtSearchProdAssign').on('keypress', (e) => {
      var key = e.which;

      var dInput = e.target.value;
      if (dInput.length <= 2 && key == 13) {
        $('header .searchForm .errorMessage').show();
        setTimeout(() => {
          $('header .searchForm .errorMessage').hide();
        }, 2000);
        return false;
      } else {

        if (key == 13 && dInput.length > 2)  // the enter key code
        {

          // this.router.navigate([this.lang, 'searchResult'    ])
          this.router.navigateByUrl('/searchResult', {skipLocationChange: true}).then(() => {
            this.router.navigate([this.lang, 'searchResult']);
          });
          this.varSearch = localStorage.setItem('query', e.target.value);
          $('.searchButtonClick').click();


        }

      }
    });
  }

  disableInput() {

    $('.searchInputAllsizes').keypress(function () {
      if ($(this).val().length > 3) {
        $(this).closest('.searchInput').removeAttr('disabled');
      } else {
        $(this).closest('.searchInput').attr('disabled', 'disabled');
      }
    });
  }

  openAdvancedSearch() {
    this.matDialog.open(AdvancedSearchComponent, {
      data: {
        hayZinvorXoragrer: this.header.hayZinvorXoragrer,
        zinujXoragrer: this.header.zinujXoragrer,
        lang: this.header.lang
      },
      width: '700px'
    });
  }

  clickSearch() {

    var dInput = $('.searchInputAllsizes').val();

    if (dInput.length <= 2) {
      $('header .searchForm .errorMessage').show();
      setTimeout(() => {
        $('header .searchForm .errorMessage').hide();
      }, 2000);
      return false;
    } else {
      localStorage.removeItem('categ');
      localStorage.removeItem('xoragir');
      localStorage.removeItem('year');
      this.varSearch = localStorage.setItem('query', dInput);
      this.router.navigate([this.lang, 'searchResult']);
      setTimeout(() => {
        location.reload();
      }, 300);


    }
  }

  search1() {
    $('#txtSearchProdAssign1').on('keypress', (e) => {
      var key = e.which;

      var dInput = e.target.value;
      if (dInput.length <= 2 && key == 13) {
        $('header .searchForm .errorMessage').show();
        setTimeout(() => {
          $('header .searchForm .errorMessage').hide();
        }, 2000);
        return false;
      } else {

        if (key == 13 && dInput.length > 2)  // the enter key code
        {


          this.varSearch = localStorage.setItem('query', e.target.value);
          // this.router.navigate([this.lang, 'searchResult'    ])
          this.router.navigateByUrl('/searchResult', {skipLocationChange: true}).then(() => {
            this.router.navigate([this.lang, 'searchResult']);
          });
          $('.searchButtonClick1').click();
          setTimeout(() => {
            location.reload();
          }, 300);


        }

      }
    });
  }

  muteUnmute() {
    $('.muteUnmute i').toggleClass('fa-volume-up', 'fa-volume-mute');
    if ($('#video').prop('muted')) {
      $('#video').prop('muted', false);

    } else {
      $('#video').prop('muted', true);
    }
  }

  ngOnInit() {
    console.log(this._location.path());
    $('video').prop('muted', true);

    this.disableInput();
    //  this.headerImage = localStorage.getItem('headerImage' )?localStorage.getItem('headerImage' ):;
    this.search();
    this.search1();
    this.menufix();
    if (!this.lang) {
      this.dataLang = '../../assets/img/armenia-flag-icon-16.png';
      var lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'hy';
      this.setHeaderLang(lang);
      // $('.choosenLanguage').val().trigger("change")
    } else {
      this.setHeaderLang(this.lang);
      this.dataLang = localStorage.getItem('langimageLang') ? localStorage.getItem('langimageLang') : '../../assets/img/armenia-flag-icon-16.png';
      // $('.choosenLanguage').val(this.lang).trigger("change")
    }

    this.changeLanguage();


    this.http.get<Header>(this.globals.urlMain + 'header').subscribe(data => {
      this.header = data;
      this.header.zinuj.reverse();
      this.header.live.reverse();
      this.header.handesner.reverse();
    });


  }

  changeLang(event) {
//  console.log(event)
    this.lang = event;
    this.translateService.langData(event);
    localStorage.setItem('lang', this.lang);
    setTimeout(() => {
      var href = location.href;
      console.log(href);
      location.href = href;
      location.reload();
    }, 200);
  }

  reload(event) {
    var target = event.currentTarget;


    target.classList.add('highlighted');
    setTimeout(() => {
      this.router.navigateByUrl('', {skipLocationChange: true}).then(() => {
        console.log(decodeURI(this._location.path()));
        this.router.navigate([decodeURI(this._location.path())]);
      });
    }, 200);

  }

  openMenu() {
    if ($(window).width() <= 1100) {
      $('header').removeClass('open');
      setTimeout(function () {
        location.reload();
      }, 200);
    }
    // else {
    //   setTimeout(function(){
    //     location.reload()
    //   }, 200)
    // }

  }

  slideTop() {
    $('html, body').animate({scrollTop: 0}, 'slow');
  };


  menufix() {
    var $document = $(document);
    $document.scroll(function () {
      if ($document.scrollTop() >= 500) {
        // user scrolled 50 pixels or more;
        // do stuff
        $('header  .menu ').addClass('fixed');
      } else if ($document.scrollTop() <= 500) {
        $('header  .menu ').removeClass('fixed');
      }
    });
  }


  changeLnagFun() {
    $('.languages .options').slideToggle();
  }

  changeLanguage() {
    $('.options p img').on('click', (e) => {
      this.imageLang = e.target.attributes.getNamedItem('src').value;
      this.lang = e.target.attributes.getNamedItem('data-attr').value;
      console.log(this.imageLang);
      this.translateService.langData(this.lang);
      localStorage.setItem('lang', this.lang);
      localStorage.setItem('langimageLang', this.imageLang);
      setTimeout(() => {
        var href = location.href;
        //  console.log(href)
        location.href = href;
        location.reload();
      }, 200);

    });

  }

  openMenuMobile() {
    $('header').toggleClass('open');
    $('.searchAndMenuMobile .searchForm').removeClass('open');
  }

  openSearchMobile() {
    $('header').removeClass('open');
    $('.searchAndMenuMobile .searchForm').toggleClass('open');
  }
}
